module.exports = __webpack_public_path__ + "4bb7b427622defaaacc9f27249d6ed38.svg";